/* PD Diwali 2026 referral capture, v2 (3 Oct 2026, staged, push set v3; live only on Abhi's go).
   A sharer's link is /collections/diwali?utm_source=referral&utm_campaign=diwali-referral&utm_content=ANJALI-JXH
   (or ?ref=ANJALI-JXH). The WhatsApp share carries the same URL. This keeps the code for 30 days in this browser and
   writes it to the cart attribute "Referral code", so it lands on the order even if the friend comes back later from
   Google or Instagram. The referral task (~/Developer/pure-desi-referral, branch offer-v2) reads that attribute first,
   then the order's UTM, then a typed "Referred by". Loaded by snippets/cart-subtotal.liquid only between
   Wed 7 Oct 00:00 and Sun 18 Oct 23:59:59 AEDT, and it checks both ends itself too.
   No UI, no layout shift, one GET /cart.js per page. */
(function () {
  if (window.__pdReferral) return;
  window.__pdReferral = true;
  var START = Date.UTC(2026, 9, 6, 13, 0, 0);           /* Wed 7 Oct 2026 00:00:00 AEDT (1791291600); moved from Tue 6 Oct on 3 Oct (invites send Wed 7 Oct 7pm) */
  var END = Date.UTC(2026, 9, 18, 12, 59, 59);          /* Sun 18 Oct 2026 23:59:59 AEDT (1792328399) */
  var now = Date.now();
  if (now < START || now > END) return;
  var KEY = 'pd_ref', ATTR = 'Referral code', DAYS = 30;
  var CODE = /^[A-Z]{1,8}-[A-Z0-9]{3,6}$/;

  function stored() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      return v && v.exp > Date.now() && CODE.test(v.code) ? v.code : null;
    } catch (e) { return null; }
  }
  function keep(code) {
    try { localStorage.setItem(KEY, JSON.stringify({ code: code, exp: Date.now() + DAYS * 864e5 })); } catch (e) {}
  }

  var q;
  try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
  var fromUrl = (q.get('utm_campaign') === 'diwali-referral' && q.get('utm_content')) || q.get('ref') || '';
  fromUrl = fromUrl.trim().toUpperCase();
  if (CODE.test(fromUrl)) keep(fromUrl);                 /* the latest link wins */

  var code = stored();
  if (!code) return;

  fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (!cart || (cart.attributes || {})[ATTR] === code) return;
      var attrs = {}; attrs[ATTR] = code;
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
    })
    .catch(function () { /* non-critical: the order's UTM and the typed box are fallbacks */ });
})();
